module.exports = __webpack_public_path__ + "static/media/var_eg.057d7c87.jpg";